import React from 'react';

import styled from "styled-components"

import { Box, Typography } from "@material-ui/core"

export default styled(React.forwardRef(({
    title,
    className,
    children
}, ref) => {
    return (
        <div className={className}>
            <Box marginBottom={1}>
                <Typography variant="subtitle2">{title}</Typography>
            </Box>
            <div className="animation-container" ref={ref}>
                {children}
            </div>
        </div>
    )
}))`
&& {
    & .animation-container {
        border: 1px solid rgba(0,0,0,0.2);
        border-radius: 4px;
        min-height: 100px;
        min-width: 100px;
        overflow: hidden;
    }
}
`